"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const volkeno_react_skeleton_1 = __importDefault(require("volkeno-react-skeleton"));
require("volkeno-react-skeleton/dist/index.css");
const TableSkeleton = ({ headers }) => {
    var _a;
    return (react_1.default.createElement("div", { className: "col-md-12 admin-table" },
        react_1.default.createElement("table", { className: "table" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, headers === null || headers === void 0 ? void 0 : headers.map((col, i) => (react_1.default.createElement("th", { scope: "col", key: col.text + i }, col.text))))),
            react_1.default.createElement("tbody", null, (_a = [...Array(5)]) === null || _a === void 0 ? void 0 : _a.map((item, i) => (react_1.default.createElement("tr", { key: i }, headers === null || headers === void 0 ? void 0 : headers.map((col, i) => (react_1.default.createElement("td", { key: col.text + i },
                react_1.default.createElement(volkeno_react_skeleton_1.default, { height: 30, variant: "rect" })))))))))));
};
exports.default = TableSkeleton;
